var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDragPan = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m12 24-4.587-4.587.92-.92 3.022 3.023v-8.871H2.492l3.022 3.015-.927.927L0 12l4.58-4.58.92.92-3.016 3.015h8.871v-8.87L8.333 5.506l-.92-.92L12 0l4.587 4.587-.92.92-3.022-3.023v8.871h8.863L18.486 8.34l.927-.927L24 12l-4.587 4.587-.92-.92 3.023-3.022h-8.871v8.863l3.015-3.022.927.927z"
})));
export default SvgDragPan;